import axios from "../../../../utils/axiosInceptor";
import { ALL_PLANS, PLANS } from "./constants";
import { adminService } from "../../../../configs/constants";

//business units

export const getAllPlans = () => async (dispatch) => {
  const url = `${adminService}/plan/list`;
  const {
    data: { result },
  } = await axios.get(url);
  if (result) {
    dispatch({
      type: ALL_PLANS,
      data: result,
    });
  }
};

//plans
export const getPlans =
  (page = 1) =>
  async (dispatch) => {
    const url = `${adminService}/plan?page=${page}`;
    const {
      data: { result },
    } = await axios.get(url);
    if (result) {
      dispatch({
        type: PLANS,
        data: result,
      });
    }
  };
